import React from 'react';
import '../css/Sidebar.css';
import { Link } from "react-scroll";

function Sidebar() {
    return (
        <div className="sidebar">
            <ul>
                <li className="dot__container">

                    <Link
                        activeClass="active"
                        to="banner"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">INTRO</span>
                        </span>
                    </Link>
                </li>
                <li className="dot__container">
                <Link
                        activeClass="active"
                        to="about"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">ABOUT</span>
                        </span>
                    </Link>
                </li>
                <li className="dot__container">

                <Link
                        activeClass="active"
                        to="whatido"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">MY JOB</span>
                        </span>
                    </Link>
                </li>
                <li className="dot__container">
                <Link
                        activeClass="active"
                        to="skills"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">SKILLS</span>
                        </span>
                    </Link>
                </li>
                <li className="dot__container">
                <Link
                        activeClass="active"
                        to="portfolio"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">PORTFOLIO</span>
                        </span>
                    </Link>
                </li>
                <li className="dot__container">
                <Link
                        activeClass="active"
                        to="contact"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={1000}
                    >
                        <span className="dot">
                            <span className="tooltiptext">CONTACT</span>
                        </span>
                    </Link>
                </li>
            </ul>
        </div>
    )
}

export default Sidebar
